import React from "react";
import { ModalProvider } from "../../TeamSuite/shared/components/ModalProvider";

interface Props {
  children: React.ReactNode;
}

const DocumentManagerModalProvider: React.FC<Props> = ({ children }) => {
  return <ModalProvider>{children}</ModalProvider>;
};

export default DocumentManagerModalProvider;
